export default __webpack_public_path__ + "static/media/loading.48c31efa.gif";